// extracted by mini-css-extract-plugin
module.exports = {"content":"purchaseControl_content__HcCA8","total":"purchaseControl_total__1BoQs","nameText":"purchaseControl_nameText__1zhw8","productText":"purchaseControl_productText__1cDEY"};